import React, { useState } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import StudentDeactivation from "./StudentDeactivation";
import SBDeactivation from "./StudentBulkDeactivation";
const DeactivationStudent = () => {
    const [DType, SetDType] = useState(0);
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking/>
                <div className="MainHeading">Students Deactivation</div>
                <div className="dflex gap-3 alignitems JCCenter mt-2">
                    {[0, 1].map((Type) => (<div className="dflex alignitems gap-2" >
                        <input type="radio" value={Type} checked={DType == Type} onChange={(e) => { SetDType(e.target.value); }} />
                        Deactivation by {Type ? "Using Template" : "Text Input"}
                    </div>))}
                </div>
                {parseInt(DType) ? <SBDeactivation/> : <StudentDeactivation/> } 
            </div>
        </>
    )
}
export default DeactivationStudent;